export const MAX_BATCH_VIDEO_COUNT = 20
export const BATCH_MEDIA_DOWNLOAD_TIMEOUT_MS = 300000

function isVideo(item) {
  const fileType = String(item && item.fileType)
  return fileType === '1' || fileType === '2'
}

export function validateBatchMediaDownload(items, zip) {
  const selection = Array.isArray(items) ? items : []
  const videoCount = selection.filter(isVideo).length
  if (zip && videoCount > MAX_BATCH_VIDEO_COUNT) {
    return {
      valid: false,
      videoCount,
      message: `打包下载一次最多选择 ${MAX_BATCH_VIDEO_COUNT} 个视频，请减少视频数量后重试`
    }
  }
  return { valid: true, videoCount }
}

export function batchMediaDownloadErrorMessage(error) {
  const serverMessage = error && error.response && error.response.data && error.response.data.msg
  if (serverMessage) return serverMessage

  const status = Number(error && error.response && error.response.status)
  const responseText = error && error.response && typeof error.response.data === 'string'
    ? error.response.data
    : ''
  const message = String((error && error.message) || '')
  const timedOut = (error && error.code === 'ECONNABORTED') ||
    [502, 503, 504].includes(status) ||
    /execution timed out|timeout|timed out/i.test(`${message} ${responseText}`)

  return timedOut
    ? '媒资打包超过5分钟，请减少视频数量后重试'
    : '媒资下载失败'
}
